<div class="layout-wrapper relative" [class]="containerClass">
  <app-topbar (loading)="setLoading($event)"></app-topbar>
  <app-sidebar></app-sidebar>
  <div class="layout-main-container">
    <div class="layout-main">
      <router-outlet></router-outlet>
    </div>
    <app-footer></app-footer>
  </div>
  <div class="layout-mask animate-fadein"></div>
  @if(loading()){
  <div
    class="fixed inset-0 z-9999 flex items-center justify-center bg-black/40 backdrop-blur-sm"
  >
    <p-progress-spinner ariaLabel="loading" />
  </div>
  }
</div>
